import { useEffect, useState } from 'react';

import { Button } from "react-bootstrap";

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UsersDashboardCards from '../../components/admin/users/UsersDashboardCards.jsx';
import UserModal from '../../components/admin/users/UserModal.jsx';
import UsersTable from '../../components/admin/users/UsersTable.jsx';

function UsersPage(props) {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        setIsLoading(true)
        fetch('http://www.terradata.com.br/api/users/list-all.php')
            .then(response => response.json())
            .then(data => {
                console.log(data)
                setUsers(data)
                setIsLoading(false)
            })    // Manipula os dados
            .catch(error => console.error('Erro:', error));
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <div className="d-flex justify-content-between mb-4">

                        <h3 style={{ color: '#fff' }}>Gerenciamento de Usuários</h3>

                        <Button onClick={() => setShowModal(true)}>
                            <FontAwesomeIcon icon={faPlus} /> Novo Usuário
                        </Button>

                    </div><UsersDashboardCards /><UsersTable users={users} /><UserModal
                        show={showModal}
                        onHide={() => setShowModal(false)} />
                </>
            }
            {isLoading && <>
                Loading...
            </>}
        </div>
    </>
}

export default UsersPage;